import { render, staticRenderFns } from "./busOrder7.vue?vue&type=template&id=19e518f5&scoped=true&"
import script from "./busOrder7.vue?vue&type=script&lang=js&"
export * from "./busOrder7.vue?vue&type=script&lang=js&"
import style0 from "./busOrder7.vue?vue&type=style&index=0&id=19e518f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e518f5",
  null
  
)

export default component.exports